import React from 'react'
import { Route, Switch , } from 'react-router-dom';
// import Login from '../app/pages/login';
// import SignUp from '../app/pages/signup';
import Home from '../app/page/home';
import Shop from '../app/page/shop';
import Profile from '../app/page/profile';
import ChangePassword from '../app/page/change-password';
import CartPage from '../app/page/cart-page';
import Wishlist from '../app/page/washlist';
import OurStory from '../app/page/ourStory';
import Contact from '../app/page/contact-us';
import SpecialOffer from '../app/page/special-offer';
import ShopSingle from '../app/page/single-category';
import Policy from '../app/page/policy';
import Carreer from '../app/page/carrers';
import Seacher from '../app/page/searcher';
import FaQs from '../app/page/faqs';
import OrderTrancking from '../app/page/order-tracking'
import SingleProduct from '../app/page/single-product';
import Login from '../app/page/login';
import Donation from '../app/page/donate';
import Signup from '../app/page/singup';
/** router providing user related routes
 * @module routers/users
 * @requires react-router-dom
 * @description this react module will help us in navigation
 */
const Routes = () => {
    return(
    <Switch>
    <Route 
        exact 
        path="/" 
        component={Home} 
    />
    <Route 
        exact 
        path="/donate" 
        component={Donation} 
    />
    <Route 
        exact 
        path="/signup" 
        component={Signup} 
    />
     <Route 
        exact 
        path="/login" 
        component={Login} 
    />
     <Route 
        exact 
        path="/seacher" 
        component={Seacher} 
    />
    <Route 
        exact 
        path="/product/:name" 
        component={SingleProduct} 
    />
     <Route 
        exact 
        path="/order/trancking" 
        component={OrderTrancking} 
    />
    <Route 
        exact 
        path="/faqs" 
        component={FaQs} 
    />
    <Route 
        exact 
        path="/carreer" 
        component={Carreer} 
    />
    <Route 
        exact 
        path="/policy" 
        component={Policy} 
    />
    <Route 
        exact 
        path="/shop/:name" 
        component={ShopSingle} 
    />
    <Route 
        exact 
        path="/specail/offers" 
        component={SpecialOffer} 
    />
     <Route 
        exact 
        path="/profile" 
        component={Profile} 
    />
    <Route 
        exact 
        path="/contact" 
        component={Contact} 
    />
     <Route 
        exact 
        path="/our/story" 
        component={OurStory} 
    />
     <Route 
        exact 
        path="/wishlist" 
        component={Wishlist} 
    />
     <Route 
        exact 
        path="/cart" 
        component={CartPage} 
    />
    <Route 
        exact 
        path="/profile/change/password" 
        component={ChangePassword} 
    />
    <Route 
        exact 
        path="/shop" 
        component={Shop} 
    />  
   
    {/* <ClientRouter />       */}
    </Switch> 
    )
}
export default Routes;